import { ButtonSecondary, Media, ExternalLink, StyledLink, UI } from '@cowprotocol/ui'

import styled from 'styled-components/macro'

import { YellowCard } from 'legacy/components/Card'
import { CopyIcon, TransactionStatusText } from 'legacy/components/Copy'

import { TransactionInnerDetail } from 'common/pure/TransactionInnerDetail'

import {
  StatusLabelWrapper,
  Summary,
  SummaryInner,
  TextAlert,
  TransactionStatusText as ActivityDetailsText,
  TransactionWrapper,
} from '../../containers/Transaction/styled'

export const WalletName = styled.div`
  width: initial;
  font-size: 0.825rem;
  font-weight: 500;
  color: ${({ theme }) => theme.info};
`

export const IconWrapper = styled.div<{ size?: number }>`
  ${({ theme }) => theme.flexColumnNoWrap};
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  border-radius: ${({ size }) => (size ? size + 'px' : '32px')};
  height: ${({ size }) => (size ? size + 'px' : '32px')};
  width: ${({ size }) => (size ? size + 'px' : '32px')};

  ${Media.upToMedium()} {
    align-items: flex-end;
  }

  & > img,
  span {
    height: ${({ size }) => (size ? size + 'px' : '32px')};
    width: ${({ size }) => (size ? size + 'px' : '32px')};
  }
`

export const TransactionListWrapper = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap};
`

export const WalletIconSmall = styled.img`
  width: 16px;
  height: 16px;
`

export const WalletAction = styled(ButtonSecondary)`
  width: fit-content;
  font-weight: 400;
  margin-left: 8px;
  font-size: 0.825rem;
  padding: 4px 6px;

  :hover {
    cursor: pointer;
    text-decoration: underline;
  }

  ${WalletIconSmall} {
    margin-left: 5px;
  }
`

export const WalletActions = styled.div`
  display: flex;
  margin: 10px 0 0;
  flex-flow: column wrap;
  gap: 10px;
  align-items: flex-start;
`

export const AddressLink = styled(ExternalLink)<{ hasENS: boolean; isENS: boolean }>`
  font-size: 0.825rem;
  color: inherit;
  margin-left: 1rem;
  font-size: 0.825rem;
  display: flex;
  :hover {
    color: inherit;
  }
`

export const AccountControl = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 0;
  width: 100%;
  font-weight: 500;
  font-size: 1.25rem;

  a:hover {
    text-decoration: underline;
  }

  p {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const UnsupportedWalletBox = styled.div`
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin-top: 60px;
  padding-bottom: 48px;
`

export const WalletSecondaryActions = styled.div``

export const WalletNameAddress = styled.div`
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 0 8px;
`

export const Wrapper = styled.div`
  ${WalletName},
  ${AddressLink},
  ${CopyIcon},
  ${WalletAction} {
    color: inherit;
    opacity: 0.85;
    transition:
      color var(${UI.ANIMATION_DURATION}) ease-in-out,
      opacity var(${UI.ANIMATION_DURATION}) ease-in-out;
    margin: auto;
    padding: 0;
    border: 0;
    font-size: 14px;
    font-weight: normal;

    &:focus,
    &:hover {
      opacity: 1;
      transform: none;
      box-shadow: none;
      border: 0;
    }
  }

  ${IconWrapper} {
    margin: 0;
  }

  ${TransactionStatusText} {
    order: 2;
    margin: 0 0 0 8px;
    align-self: center;
    font-size: 21px;
    color: inherit;
  }

  ${WalletName} {
    width: 100%;
    text-align: center;
    justify-content: center;
    margin: 0;
    font-size: 12px;
  }

  ${TransactionListWrapper} {
    padding: 0;
    width: 100%;
    flex-flow: column wrap;
  }

  ${AccountControl} {
    ${Media.upToSmall()} {
      align-items: center;
    }
  }

  ${AccountControl} ${WalletSecondaryActions} {
    width: 100%;
    margin: 0;
    padding: 0;
    display: grid;
    gap: 8px;
    justify-items: flex-end;

    ${Media.upToSmall()} {
      justify-items: center;
      margin: 12px auto 0;
    }

    > a,
    > button {
      align-items: center;
      background: transparent;
      min-height: initial;
      cursor: pointer;
      animation: none;
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }
  }

  ${AccountControl} ${WalletActions} {
    ${Media.upToSmall()} {
      width: 100%;
      flex-flow: row wrap;
      justify-content: center;
      margin: 12px auto;
    }
  }
`

export const WalletWrapper = styled.div`
  > div > img[alt='Gnosis Safe Multisig logo'] {
    ${({ theme }) => theme.invertImageForDarkMode};
  }
`

export const InfoCard = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  border-radius: 16px;
  padding: 24px;
  background: var(${UI.COLOR_PAPER_DARKER});
  color: inherit;

  &:not(:first-child) {
    margin: 24px 0;
  }

  ${Media.upToSmall()} {
    padding: 16px 10px 24px;

    &:not(:first-child) {
      margin: 16px 0;
    }
  }
`

export const AccountGroupingRow = styled.div`
  justify-content: space-between;
  align-items: center;
  color: inherit;

  div {
    ${({ theme }) => theme.flexRowNoWrap}
    align-items: center;
  }

  margin: 0;

  ${Media.upToSmall()} {
    width: 100%;
  }

  > div {
    flex-flow: column wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const CreationDateRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
`

export const GetNotifiedButton = styled.button`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 6px;
  cursor: pointer;
  border-radius: 16px;
  background: var(${UI.COLOR_PAPER});
  border: 1px solid var(${UI.COLOR_TEXT_OPACITY_10});
  color: var(${UI.COLOR_TEXT});
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  padding: 12px;
  transition:
    background var(${UI.ANIMATION_DURATION}) ease-in-out,
    border-color var(${UI.ANIMATION_DURATION}) ease-in-out;

  > svg {
    flex: 0 0 auto;
    color: inherit;
  }

  &:hover {
    background: var(${UI.COLOR_PAPER_DARKER});
    border-color: var(${UI.COLOR_PAPER_DARKER});
  }

  &:focus-visible {
    outline: 2px solid var(${UI.COLOR_PRIMARY});
    outline-offset: 2px;
  }

  ${Media.upToSmall()} {
    width: 100%;
    justify-content: center;
  }
`

export const NoActivityMessage = styled.p`
  font-size: 14px;
  color: inherit;
  width: 100%;
  margin: 24px 0 0;
  text-align: center;
  display: flex;
  justify-content: center;
`

export const LowerSection = styled.div`
  border-radius: 0;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  color: inherit;
  padding: 0 0 48px;

  > div {
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    background-color: inherit;
    padding: 0;
    color: inherit;

    > ${StyledLink} {
      width: 100%;
      text-align: center;
      margin: 24px auto 0;
    }
  }
`

export const ActivityHeader = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: inherit;
  gap: 8px 12px;
  padding: 0 0 12px;
  width: 100%;

  ${Media.upToMedium()} {
    top: 42px;
  }

  > h5 {
    order: 1;
    margin: 0;
    font-weight: 500;
    color: inherit;
    line-height: 1;
    display: flex;
    align-items: center;

    > span {
      opacity: 0.6;
      margin: 0 0 0 4px;
      color: inherit;
    }
  }

  > button {
    order: 2;
  }

  > ${StyledLink} {
    order: 3;
    margin-left: auto;
    color: inherit;
    text-decoration: underline;
    font-size: 14px;

    &:hover {
      color: ${({ theme }) => theme.info};
    }
  }

  ${Media.upToSmall()} {
    row-gap: 24px;

    > button {
      order: 0;
      flex: 1 1 100%;
      margin-top: -12px;
    }
  }
`

// TODO: Prevent beyond 3 level selector nestings
export const LowerSectionSimple = styled(LowerSection)`
  padding: 0;

  > div {
    padding: 0;

    ${StyledLink} {
      align-self: center;
      margin: 7px 0 0;
      font-size: 12px;
    }
    ${TransactionWrapper} {
      padding: 15px;

      > div > ${ActivityDetailsText} {
        width: 100%;
        margin: 0;
      }

      > div > ${ActivityDetailsText} > ${Summary} {
        grid-template-columns: 1fr auto;
        grid-template-rows: max-content;
        align-items: center;
        gap: 16px;

        > span {
          display: none;
        }

        > ${SummaryInner} {
          // Gnosis safe
          > ${TransactionInnerDetail} {
            padding: 0;
            border: none;
            margin-top: 10px;
            > a {
              align-self: flex-start;
            }
            > span:last-of-type {
              margin: 3px 0 0px;
            }
            > ${TextAlert} {
              margin: 10px 0 6px;
            }
          }
          ${Media.upToSmall()} {
            margin: 16px 0;
          }

          > b {
            display: none;
          }
        }

        > ${StatusLabelWrapper} {
          margin: 0;
        }
      }
    }
  }
`

const NetworkCardUni = styled(YellowCard)`
  border-radius: 12px;
  padding: 8px 12px;

  ${Media.upToSmall()} {
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  }
`

export const NetworkCard = styled(NetworkCardUni)`
  background-color: var(${UI.COLOR_PAPER});
  color: inherit;
  padding: 6px 8px;
  font-size: 13px;
  margin: 0;
  letter-spacing: 0.7px;
  min-width: initial;
  flex: 0 0 fit-content;

  ${Media.upToSmall()} {
    margin: 0 auto 12px;
  }
`

export const WalletSelector = styled.div`
  display: flex;
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  transition: background var(${UI.ANIMATION_DURATION}) ease-in-out;
`
